export const configTir = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "TIR - Coef. de variation",
      padding: 20,
    },
    legend: {
      position: "bottom",
    },
    datalabels: {
      align: "top",
      offset: -5,
      backgroundColor: function (context) {
        return "#000000";
      },
      borderRadius: 4,
      color: "white",
      font: {
        weight: "bold",
      },
      //formatter: Math.round,
      padding: 6,
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      // grid line settings
      grid: {
        drawOnChartArea: true, // only want the grid lines for one axis to show up
      },
    },
  },
};

export const dataConfigTir = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "CV",
      data: data.cv,
      borderColor: "#000000",
      backgroundColor: "#000000",
      yAxisID: "y1",
      type: "line",
      datalabels: { display: true },
    },
    {
      label: "TBR",
      data: data.tbr,
      backgroundColor: "rgb(220,20,60)",
      datalabels: { display: false },
    },
    {
      label: "TIR",
      data: data.tir,
      backgroundColor: "#00891e",
      datalabels: { display: false },
    },
    {
      label: "TAR",
      data: data.tar,
      backgroundColor: "#ffa321",
      datalabels: { display: false },
    },
  ],
});
